export default __webpack_public_path__ + "static/media/cursor gif.e34c596c.gif";